<template>
  <div>

        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>退货订单</span>
            <div class="float-right" v-if="applyReturnOrderManageInfo.orders.length === 0">
              <el-button type="primary" size="small" @click="openAddShopHouseModal">
                <i class="el-icon-plus"></i>选择订单
              </el-button>
            </div>
          </div>
          <el-table :data="applyReturnOrderManageInfo.orders" style="width: 100%" border stripe>
            <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
            <el-table-column prop="personName" label="用户" align="center"></el-table-column>
            <el-table-column prop="totalPrice" label="总金额" align="center"></el-table-column>
            <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
            <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination-container" background layout="prev, pager, next" :total="total"
            :current-page="currentPage" :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
        </el-card>


        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>说明</span>
          </div>
          <el-form label-position="right" label-width="100px">
            <el-form-item label="退货说明">
              <el-input type="textarea" v-model="applyReturnOrderManageInfo.remark" placeholder="必填，请填写进货说明"
                maxlength="250" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div class="button-group">
            <el-button type="primary" class="float-right" @click="doInoutOrder">
              <i class="el-icon-check"></i>提交
            </el-button>
            <el-button type="warning" class="float-right" style="margin-right: 20px;" @click="goBack">
              <i class="el-icon-close"></i>取消
            </el-button>
          </div>
        </el-card>

    <choose-store-order ref="chooseStoreOrder" @chooseStoreOrder="handleChooseStoreOrder"></choose-store-order>
  </div>
</template>

<script>
import { applyReturnStoreCarts } from '@/api/goods/applyReturnOrderApi'
import ChooseStoreOrder from '@/components/goods/chooseStoreOrder/ChooseStoreOrder'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ApplyReturnOrderManage',
  components: {
    ChooseStoreOrder
  },
  data() {
    return {
      applyReturnOrderManageInfo: {
        rsId: '',
        supplierName: '',
        orders: [],
        orderId:'',
        remark: '',
        totalMount: 0.00,
        orderType: '10000',
        shopId: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.applyReturnOrderManageInfo.shopId = getShopId()
    console.log(this.total)
  },
  methods: {
    handleChooseStoreOrder(product) {
      this.applyReturnOrderManageInfo.orders.push(product)
    },
    async doInoutOrder() {
      if (this.applyReturnOrderManageInfo.orders.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      try {
        this.applyReturnOrderManageInfo.orderId = this.applyReturnOrderManageInfo.orders[0].orderId
        const res = await applyReturnStoreCarts(this.applyReturnOrderManageInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error(error)
      }
    },
    openAddShopHouseModal() {
      this.$refs.chooseStoreOrder.open()
    },
    goBack() {
      this.$router.go(-1)
    },
    deleteProduct(inoutOrderProduct) {
      const index = this.applyReturnOrderManageInfo.orders.indexOf(inoutOrderProduct)
      if (index > -1) {
        this.applyReturnOrderManageInfo.orders.splice(index, 1)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 这里可以添加分页请求数据的逻辑
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.float-right {
  float: right;
}

.button-group {
  margin-top: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>